export const TERMS_VERSION = "2026-10-21";
export const TERMS_UPDATED = "October 21, 2026";

export const TERMS_SECTIONS = [
  {
    id: "education",
    title: "Educational use only",
    body: [
      "The Manager Operating System is educational material. It shares frameworks, examples, scripts, and templates to help you think through the work of managing people.",
      "It is not legal, HR, medical, mental-health, or financial advice. Every workplace, team, and situation is different, so please use your own judgment when applying anything here. For situations involving employment law, discipline or termination, harassment, safety, health, or wellbeing, follow your organization's policies and talk with HR, legal counsel, or a qualified professional.",
      "You are responsible for the decisions you make. Manage(Meant) Excellence isn't liable for outcomes that come from applying this material.",
    ],
  },
  {
    id: "privacy",
    title: "Privacy, in plain words",
    body: [
      "Your email address is used to create your account, sign you in, send you your access and receipt, and send occasional helpful emails. Every marketing email has a one-click unsubscribe link.",
      "At checkout, Stripe, our payment processor, collects your name, billing address, phone number, and payment details to process your payment and handle sales tax. We never see or store your full card number.",
      "Inside the toolkit, we save your progress, your downloads, and any notes or templates you create so they're there when you come back. If you send a toolkit as a gift, we use your colleague's email only to deliver their access. We also count page visits anonymously to understand what's helpful.",
      "We never sell your information. We share it only with the services that run this product, such as payment processing and email delivery, and only as needed to provide it to you. Want your account and data deleted? Email us and we'll take care of it.",
    ],
  },
  {
    id: "license",
    title: "Your license to use the toolkit",
    body: [
      "When you buy a toolkit, you receive a personal, single-user license. Your login and full access to the toolkit are for you.",
      "You're encouraged to put what you learn to work with your team. Talk about the ideas, use the frameworks in your conversations, and share completed templates (such as a one-on-one agenda or a filled-in plan) as part of supporting the people you manage.",
      "If you'd like someone else to have full access to the toolkit, please purchase a copy for them. Manage(Meant) Excellence is a small business, and each license directly supports the work of creating these resources. For the same reason, please don't share your login, distribute blank copies of the templates or toolkit content, or resell, republish, or post the material publicly. If you'd like access for several people or your organization, reach out and we'll be glad to set that up.",
      "All content remains the property of Manage(Meant) Excellence.",
    ],
  },
  {
    id: "refunds",
    title: "Refunds",
    body: [
      "If the toolkit doesn't help, email us within 14 days of purchase and we'll refund you in full. No scripts, no hoops.",
    ],
  },
  {
    id: "contact",
    title: "Questions",
    body: [
      "Email hello@managemeantexcellence.com with any questions about these terms, your data, or your purchase. We may update these terms from time to time, and we'll show the updated date at the top of this page.",
    ],
  },
];
